import { useMemo } from 'react';
import { parseFFListings } from '../utils/ffParser';

/** Parse FF HTML and apply user filters. Returns listings, price bounds, and filtered list. */
export function useFFListings({ ffHtml, petsFilter, ffMinPrice, ffMaxPrice, ffMinBeds, ffMinBaths }) {
  const ffListings = useMemo(() => (ffHtml ? parseFFListings(ffHtml) : []), [ffHtml]);

  const ffPriceBounds = useMemo(() => {
    const prices = ffListings
      .map((l) => l.amountNumeric)
      .filter((n) => typeof n === 'number' && Number.isFinite(n) && n > 0);
    if (!prices.length) return { min: null, max: null };
    let min = prices[0];
    let max = prices[0];
    for (let i = 1; i < prices.length; i++) {
      if (prices[i] < min) min = prices[i];
      if (prices[i] > max) max = prices[i];
    }
    return { min, max };
  }, [ffListings]);

  const ffListingsFiltered = useMemo(() => {
    let list = ffListings;
    if (petsFilter === 'pets') {
      list = list.filter((l) => l.petsAllowed === true);
    } else if (petsFilter === 'no-pets') {
      list = list.filter((l) => l.petsAllowed === false);
    }
    if (typeof ffMinPrice === 'number') {
      list = list.filter((l) => l.amountNumeric == null || l.amountNumeric >= ffMinPrice);
    }
    if (typeof ffMaxPrice === 'number' && ffMaxPrice > 0) {
      list = list.filter((l) => l.amountNumeric == null || l.amountNumeric <= ffMaxPrice);
    }
    if (typeof ffMinBeds === 'number' && ffMinBeds > 0) {
      list = list.filter((l) => l.bedroomCount == null || l.bedroomCount >= ffMinBeds);
    }
    if (typeof ffMinBaths === 'number' && ffMinBaths > 0) {
      list = list.filter((l) => l.bathroomCount == null || l.bathroomCount >= ffMinBaths);
    }
    return list;
  }, [ffListings, petsFilter, ffMinPrice, ffMaxPrice, ffMinBeds, ffMinBaths]);

  return { ffListings, ffPriceBounds, ffListingsFiltered };
}
